export const leadValues = {
    NAME: 'name',
    STATUS: 'status',
    COMPANY: 'company',
    EMAIL: 'email',
    PHONE: 'phone',
    ACTION_STATUS: 'action-status'
}
